import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";

const apiUrl: string = `${hostname}/aladdin_api/v1`;

function runOptifundBizLayerQuery(
  oauthTokenHeader: string,
  queryId: string,
  websiteSharedUid: string,
  startDate?: string,
  endDate?: string,
  brand?: string,
  month?: number,
  year?: number
) {
  const params = new URLSearchParams({
    website_shared_uid: websiteSharedUid,
  });
  if (startDate) params.set("start_date", startDate);
  if (endDate) params.set("end_date", endDate);
  if (brand) params.set("brand", brand);
  if (month !== undefined) params.set("month", String(month));
  if (year !== undefined) params.set("year", String(year));

  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${queryId}/?${params.toString()}`,
    oauthTokenHeader
  );
}

export const optifundDashboardService = {
  runOptifundBizLayerQuery,
};
